module.exports = __webpack_public_path__ + "static/media/ico-agenda.00fec38c.svg";